import React, { useState, useEffect } from "react";
import { BulkRiderBatch } from "../../../../services/batch.service";
import FormBAtchRider from "../../../../components/forms/FormBAtchRider";
import { swalNotification } from "../../../../components/alret/notificztion";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Upload, Space } from "antd";
import {
  UploadOutlined,
  RollbackOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { validationErrors } from "../../../../utils/Helpers";
const { Title } = Typography;
const BulkBatchRider = () => {
  const navigate = useNavigate();
  const pagename = "Batch";
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState(null);
  const [dataForApi, setDataForApi] = useState(null);
  const [MBtnLoading, setMBtnLoading] = useState(false);

  useEffect(() => {
    if (dataForApi) {
      setDataForApi(null);
    }
    if (data) {
      convertDataForApi(data);
    }
  }, [data]);

  const convertDataForApi = () => {
    let dataToConvert = [];
    data.map((item, idx) => {
      const shiftDto = {
        tszone: item.zone,
        tsstartTimeInSec: convertDateToSecond(item.startTime),
        tsshiftDuration: item.shiftDuration,
        tsslots: item.slots,
      };
      dataToConvert.push(shiftDto);
    });
    setDataForApi(dataToConvert);
  };

  const convertDateToSecond = (payload) => {
    const newStartTime = new Date(payload);
    return newStartTime.valueOf();
  };

  const [fileList, setFileList] = useState([]);
  const props = {
    onRemove: (file) => {
      setData("");
      setInitialValues(null);
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setMBtnLoading(true);
      const promise = new Promise((resolve, reject) => {
        setFileList([...fileList, ""]);
        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
        fileReader.onload = (e) => {
          const bufferArray = e.target.result;
          const wb = XLSX.read(bufferArray, { type: "buffer" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws);
          const initialValues = {
            rider_batchs_data: data,
          };
          setInitialValues(initialValues);
          resolve(data);
        };
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
      promise.then((d) => {
        setData("");
        setData(d);
      });
      setFileList([...fileList, file]);
      setMBtnLoading(false);
      return false;
    },
    fileList,
  };

  const onFinish = async (values) => {
    const newData = values.rider_batchs_data;
    try {
      setMBtnLoading(true);
      const resp = await BulkRiderBatch(newData);
      if (resp.data.code == 200) {
        swalNotification("Rider Batch Assign", resp.data.message, "success");
        navigate("/rider");
      }
    } catch (error) {
      validationErrors(error);
    } finally {
      setMBtnLoading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>Rider {pagename} Bulk Assign</Title>
        </div>
        <div className="pch">
          <Space>
            <Upload className="rockyupload" {...props}>
              <Button
                disabled={fileList.length === 1}
                icon={<UploadOutlined />}
                loading={MBtnLoading}
              >
                Select File
              </Button>
            </Upload>
            <Button>
              <Link
                to="/files/sample-file-bulk-rider-batch.csv"
                target="_blank"
                download
              >
                <DownloadOutlined /> Download Sample File
              </Link>
            </Button>
            <Button onClick={() => navigate("/batch")}>
              <RollbackOutlined />
            </Button>
          </Space>
        </div>
      </div>
      {initialValues && (
        <FormBAtchRider
          initialValues={initialValues}
          onFinish={onFinish}
          MBtnLoading={MBtnLoading}
        />
      )}
    </div>
  );
};
export default BulkBatchRider;
